import React from 'react';

const HammerEmojiIcon = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.1558 28.3395C27.1958 29.3795 28.8505 29.4286 29.8316 28.4474C30.8128 27.4662 30.7637 25.8116 29.7237 24.7716L10.3161 5.36395C9.27606 4.32391 7.62144 4.27485 6.64027 5.25602C5.6591 6.2372 5.70816 7.89181 6.7482 8.93185L26.1558 28.3395Z"
        fill="#F4900C"
      />
      <path
        d="M19.1279 0.796143C19.1279 0.796143 13.7761 -1.87978 9.31619 2.58009L3.07236 8.82392C3.07236 8.82392 2.18038 7.93195 1.28841 8.82392L0.396433 9.7159C0.396433 9.7159 -0.495542 10.6079 0.396433 11.4998L3.96433 15.0677C3.96433 15.0677 4.85631 15.9597 5.74829 15.0677L6.64026 14.1758C6.64026 14.1758 7.53224 13.2838 6.64026 12.3918L6.57069 12.3222C7.25751 11.6595 8.28596 10.9843 9.31619 11.4998L12.8841 7.93195C12.8841 7.93195 11.9921 5.25602 13.7761 3.47207C15.56 1.68812 16.452 1.68812 18.2359 1.68812C20.0199 1.68812 19.1279 0.796143 19.1279 0.796143Z"
        fill="#66757F"
      />
    </svg>
  );
};

export default HammerEmojiIcon;
